export { ConfluenceEmbeddedView } from './confluence-embedded-view';
